import { Accordion, Icons, Stack, Text, styled } from "@/theme/index";
import { commaFormatCurrency } from "@/utils/index";
import { IconContainer } from "src/v2";

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  border: 0,

  borderBottom: `1px solid ${theme.palette.divider}`,
  margin: 0,
  "::before": {
    display: "none",
  },
  ":hover": {
    boxShadow: "none",
  },
  ".MuiAccordionDetails-root": {
    padding: "20px",
    backgroundColor: theme.palette.primary.light,
  },
  "&.Mui-expanded": {
    margin: 0,
  },
  ".MuiAccordionSummary-root": {
    flexDirection: "row-reverse",
    padding: 0,
  },
  ":last-of-type": {
    borderRadius: 0,
  },
}));

export interface AssetsAccordionProps {
  icon: React.ReactNode;
  count: number;
  title: string;
  value: number;
  children: NonNullable<React.ReactNode> & React.ReactNode;
}

export function AssetsAccordion({
  icon,
  count,
  title,
  value,
  children,
}: AssetsAccordionProps) {
  return (
    <StyledAccordion
      display={
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          width={"100%"}
        >
          <Stack direction={"row"} alignItems={"center"}>
            <IconContainer icon={icon} sx={{ mx: { xs: 1, md: 2 } }} />
            <Stack direction={"row"}>
              <Text variant="body1" width={{ xs: "75px", md: "100px" }}>
                {title}
              </Text>
              <Text variant="body1" marginLeft={2}>
                {count}
              </Text>
            </Stack>
          </Stack>
          <Text variant="body1">{commaFormatCurrency(value, true)}</Text>
        </Stack>
      }
      color="inherit"
      customExpandIcon={<Icons.ExpandMore sx={{ color: "black" }} />}
    >
      {children}
    </StyledAccordion>
  );
}
